var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      staticClass: "fill-height justify-center",
      attrs: { id: "stream", tag: "section" }
    },
    [
      _c("v-fade-transition", [
        _c("div", { staticClass: "status" }, [
          _vm.streamStatus === _vm.StreamStatus.INIT
            ? _c("div", { staticClass: "fade-element" }, [
                _vm._v(
                  " " + _vm._s(_vm.$t("stream.checking-your-credentials")) + " "
                )
              ])
            : _vm._e(),
          _vm.streamStatus === _vm.StreamStatus.STARTING
            ? _c("div", { staticClass: "fade-element" }, [
                _vm._v(" " + _vm._s(_vm.$t("stream.launch-wait")) + " ")
              ])
            : _vm._e(),
          _vm.isDebugMode
            ? _c("div", { staticClass: "fade-element" }, [
                _vm._v(
                  " Running in debug mode. Please launch Unity on your local machine. "
                )
              ])
            : _vm._e(),
          _vm.error
            ? _c("div", { staticClass: "fade-element" }, [
                _c("span", { staticClass: "errorMessage" }, [
                  _vm._v(_vm._s(_vm.error))
                ])
              ])
            : _vm._e()
        ])
      ]),
      _c(
        "v-card",
        { staticClass: "stream" },
        [
          _c(
            "v-card-title",
            [
              _vm._v(" " + _vm._s(_vm.$t("stream.web-stream"))),
              _c("v-spacer"),
              _vm.streamStatus === _vm.StreamStatus.RUNNING
                ? _c(
                    "v-btn",
                    {
                      attrs: { id: "button_stop", color: "red" },
                      on: { click: _vm.showCloseConfirmDialog }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("stream.stop")) + " ")]
                  )
                : _vm._e(),
              _vm.streamStatus !== _vm.StreamStatus.INIT
                ? _c(
                    "v-btn",
                    {
                      attrs: { id: "button_maximize", color: "secondary" },
                      on: { click: _vm.maximizeIFrame }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("stream.full-screen")) + " ")]
                  )
                : _vm._e()
            ],
            1
          ),
          _c("v-card-text", [
            !_vm.error &&
            !_vm.isDebugMode &&
            _vm.streamStatus !== _vm.StreamStatus.INIT
              ? _c("div", [
                  _c("iframe", {
                    staticStyle: {
                      height: "600px",
                      width: "100%",
                      border: "none"
                    },
                    attrs: {
                      id: "vagonFrame",
                      src: _vm.streamingURL,
                      frameborder: "0",
                      allow:
                        "microphone  *; clipboard-read *; clipboard-write *; encrypted-media *;",
                      allowfullscreen: ""
                    }
                  }),
                  _c("br")
                ])
              : _vm._e()
          ])
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500px" },
          model: {
            value: _vm.showCloseConfirm,
            callback: function($$v) {
              _vm.showCloseConfirm = $$v
            },
            expression: "showCloseConfirm"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [
                _vm._v(_vm._s(_vm.$t("stream.close"))),
                _c("br")
              ]),
              _c("v-card-text", [
                _vm._v(_vm._s(_vm.$t("stop-playing-bodyswaps")))
              ]),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      on: {
                        click: function($event) {
                          _vm.showCloseConfirm = false
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("global.no")) + " ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "red" },
                      on: { click: _vm.confirmCloseDialog }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("global.yes")) + " ")]
                  ),
                  _c("v-spacer")
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }